<template>
  <div class="box">
    <div v-if="loading" class="loadingBox">
      <img src="@/assets/img/baidu/baidulytd/loading.gif" />
      <div>请稍后...</div>
    </div>
    <!-- 订单列表 -->
    <div class="list" v-if="!loading && baiduList.length">
      <div class="group" v-for="item in baiduList" :key="item.id">
        <div class="title">{{ item.goodsName || '——' }}</div>
        <div class="center">
          <div class="item">
            <div class="label">订单编号:</div>
            <div class="value">{{ orderData.orderNo }}</div>
          </div>
          <div class="item">
            <div class="label">发货时间:</div>
            <div class="value">
              {{ orderData.deliveryTime }}
            </div>
          </div>
          <div class="item" v-show="item.cardNo">
            <div class="label">卡号:</div>
            <div class="value">{{ item.cardNo }}</div>
            <div
              class="copy"
              v-clipboard:copy="item.cardNo"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
          <div class="item" v-show="item.cardPwd">
            <div class="label">卡密:</div>
            <div class="value">{{ item.cardPwd }}</div>
            <div
              class="copy"
              v-clipboard:copy="item.cardPwd"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
          <div class="item" v-show="item.verifyCode">
            <div class="label">验证码:</div>
            <div class="value">{{ item.verifyCode }}</div>
            <div
              class="copy"
              v-clipboard:copy="item.verifyCode"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
          <div class="item" v-show="item.shortUrl">
            <div class="label">短链:</div>
            <div class="value">{{ item.shortUrl }}</div>
            <div
              class="copy"
              v-clipboard:copy="item.shortUrl"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
          <div class="item" v-show="item.redeemCode">
            <div class="label">兑换码:</div>
            <div class="value">{{ item.redeemCode }}</div>
            <div
              class="copy"
              v-clipboard:copy="item.redeemCode"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
          <div class="item">
            <div class="label">有效期至:</div>
            <div class="value">{{ item.expireTime }}</div>
          </div>
          <div class="item">
            <div class="label">使用规则:</div>
            <!-- <div class="showRule" @click="showRule(index)">点击展示</div> -->
          </div>
          <div class="rule" v-html="item.gcText" />
        </div>
      </div>
    </div>
    <!-- 异步发货 -->
    <div
      class="loadingBox empty"
      v-if="!loading && [0, 2].includes(orderData.orderStatus)"
      @click="loadData()"
    >
      <img src="@/assets/img/baidu/baidulytd/loading.gif" />
      <div>
        {{ orderData.orderStatus === 2 ? '商品出库失败' : '宝贝正在狂奔...' }}
      </div>
      <div class="refresh">点击刷新</div>
    </div>
  </div>
</template>

<script>
import { exchangeList } from '@/api/baidu.js'
export default {
  data() {
    return {
      baiduList: [],
      showRuleIndex: -1,
      loading: false,
      orderData: {
        orderStatus: null // 订单状态 0发放中 1成功 2失败
      }
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      const { code, data, message } = await exchangeList({
        token: this.$route.query.token
      }).finally(() => {
        this.loading = false
      })
      if (code === 0) {
        this.orderData = data
        this.baiduList = data?.codeList || []
      } else {
        this.$toast.fail({
          message: message
        })
        this.$router.push({
          path: '/baidulytd'
        })
      }
    },
    showRule(val) {
      if (val === this.showRuleIndex) {
        this.showRuleIndex = null
        return
      }
      this.showRuleIndex = val
    },
    copySuccess() {
      this.$toast({ message: '复制成功!' })
    },
    copyError() {
      this.$toast({ message: '复制失败!' })
    }
  }
}
</script>

<style lang="less" scoped>
.box {
  min-height: 100vh;
  background: #e9eaea;
  .list {
    padding: 48px 30px;
    box-sizing: border-box;
    .group {
      background: #ffffff;
      border-radius: 30px;
      margin-bottom: 34px;
      position: relative;
      padding: 0 30px;
      .title {
        font-size: 32px;
        color: #000000;
        line-height: 80px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        box-sizing: border-box;
        border-bottom: dashed 2px #e0e2e6;
      }
      .center {
        padding-top: 34px;
        box-sizing: border-box;
        overflow: hidden;
        .item {
          display: flex;
          align-items: center;
          padding: 0 0px 40px;
          font-size: 24px;
          width: 100%;
          .label {
            color: #000000;
            width: 160px;
          }
          .value {
            flex: 1;
            width: 100%;
            color: #666666;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .copy {
            width: 96px;
            height: 40px;
            line-height: 40px;
            background: #fb3a00;
            border-radius: 20px;
            font-size: 24px;
            color: #ffffff;
            text-align: center;
          }
          .showRule {
            color: #fb3a00;
            text-decoration-line: underline;
            text-underline-offset: 6px;
            text-align: right;
            flex: 1;
          }
        }
        .rule {
          background: #ffefcc;
          border-radius: 20px;
          margin: 0 0 46px 0;
          padding: 36px 64px 28px 26px;
          font-size: 24px;
          color: #4a4a4a;
          line-height: 40px;
        }
      }
    }
  }
  .loadingBox {
    position: fixed;
    top: 30%;
    left: 50%;
    transform: translateX(-50%);
    font-size: 40px;
    color: #fb3a00;
    img {
      width: 168px;
      display: block;
      margin: 0 auto 36px;
    }
    .refresh {
      margin-top: 100px;
      width: 200px;
      line-height: 70px;
      text-align: center;
      border-radius: 35px;
      border: 2px solid #000000;
      color: #000000;
    }
  }
}
</style>
